import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const UpdateGroupMutation = graphql(`
    mutation UpdateGroup($id: ObjectID!, $input: UpdateGroupInput!) {
        updateGroup(id: $id, input: $input) {
            __typename
            ... on UpdateGroupSuccessfulResponse {
                result {
                    ...GroupItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type UpdateGroupMutationVariables = VariablesOf<typeof UpdateGroupMutation>;
